import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import { getUnique } from '../helpers/common'
import { Notification } from './notification'

const Map = ({ width, height, address }) => {
  const idMap = useRef(getUnique())

  const locale = useSelector((state) => state.i18n.locale)

  return (
    <>
      {address ? (
        <iframe
          title={idMap}
          width={width || '100%'}
          height={height || '100%'}
          loading="lazy"
          style={{ border: 0 }}
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_API_KEY}&language=${locale}&q=${address}`}
        />
      ) : (
        <div style={{ width: width || '100%', height: height || '100%' }}>
          <Notification />
        </div>
      )}
    </>
  )
}

Map.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  address: PropTypes.string,
}

export default Map
